export default __webpack_public_path__ + "static/media/HappyBirthday_13.fa74863a.png";